import { gql } from '@apollo/client';

import {
  WITH_COUNT_VARIABLES,
  WITH_COUNT_ARGUMENTS
} from '../../../queries/withCount';

const ERRORS = `errors { path, message }`;

export const QUICKBOOKS_IMPORT = gql`
  mutation QuickbooksImport(
    $name: String!
    $ownerType: String!
    $ownerId: Int
    $date: ISO8601Date
    $file: Upload!
  ) {
      quickbooksImport(
        name: $name
        ownerType: $ownerType
        ownerId: $ownerId
        date: $date
        file: $file
    ) {
      fileUpload {
        id
      }
    }
  }
`;

export const FILE_UPLOAD_FIELDS = `
  id
  name
  ownerType
  fileUrl
`;

export const FILE_UPLOADS_WITH_COUNT = gql`
  query (
    ${WITH_COUNT_VARIABLES}
  ) {
    fileUploadsWithCount(
      ${WITH_COUNT_ARGUMENTS}
    ) {
      entries {
        ${FILE_UPLOAD_FIELDS}
      }
      count
    }
  }
`;